import { IntegrationStatus } from '@features/bills/types/integrationStatus'

import { CegidIntegrationStatus } from '../enums/cegidIntegrationStatus'

export const cegidIntegrationStatusToTranslationKeys: Record<CegidIntegrationStatus, string> = {
  [CegidIntegrationStatus.Failed]: 'cegid_integration_status.failed.tooltip',
  [CegidIntegrationStatus.Pending]: 'cegid_integration_status.pending.tooltip',
  [CegidIntegrationStatus.Processing]: 'cegid_integration_status.pending.tooltip',
  [CegidIntegrationStatus.Posted]: 'cegid_integration_status.posted.tooltip',
}

type NonNullRejectionCode = Exclude<IntegrationStatus['rejectCode'], null | undefined>

export const cegidIntegrationRejectionCodeToTranslationKeys: Record<NonNullRejectionCode, string> = {
  DUPLICATE_DOCUMENT_ID: 'cegid_integration_status.rejected_reasons.duplicate_document_id',
  DUPLICATE_FILE: 'cegid_integration_status.rejected_reasons.duplicate_file',
  EMPTY_FILE: 'cegid_integration_status.rejected_reasons.empty_file',
  FAILED_TO_DOWNLOAD: 'cegid_integration_status.rejected_reasons.failed_to_download',
  OTHER: 'cegid_integration_status.rejected_reasons.other',
}

export const cegidIntegrationRejectionCodeToTooltipTranslationKeys: Record<NonNullRejectionCode, string> = {
  DUPLICATE_DOCUMENT_ID: 'cegid_integration_status.rejected_reasons.duplicate_document_id.tooltip',
  DUPLICATE_FILE: 'cegid_integration_status.rejected_reasons.duplicate_file.tooltip',
  EMPTY_FILE: 'cegid_integration_status.rejected_reasons.empty_file.tooltip',
  FAILED_TO_DOWNLOAD: 'cegid_integration_status.rejected_reasons.failed_to_download.tooltip',
  OTHER: 'cegid_integration_status.rejected_reasons.other.tooltip',
}
